import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { GUARANTEE_BODY, guaranteeSteps } from '../data/resinContent';
export function GuaranteeSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-169" data-mp="4x327s6t9bfc">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-170" data-mp="9wph062aezq9">
        <ShieldCheckIcon className="mx-auto h-9 w-9 text-champagne" strokeWidth={1.25} aria-hidden="true" data-id="element-171" data-mp="eu8uh3r5v8h5" />
        <h2 id="guarantee-title" className="mt-4 font-display text-[1.8rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-172" data-mp="js0vqodp46y0">
          7-day guarantee
        </h2>
        <ul className="mt-4 space-y-0.5" data-id="element-173" data-mp="smxfgav1l204">
          {guaranteeSteps.map(s => <li key={s} className="font-display text-lg italic leading-snug text-ivory-100 sm:text-xl" data-id="element-174" data-mp="xjfjf8ijswbe">
              {s}
            </li>)}
        </ul>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-175" data-mp="17hbr1qca194r">{GUARANTEE_BODY}</p>
        <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-176" data-mp="25sq8122fuf6k">100% refund.</p>
      </div>
    </section>;
}